export function useUser() {
  const clientUser = useSupabaseUser();
  const serverUser = useState("su", () => clientUser.value);

  const mounted = ref(false);
  onMounted(() => (mounted.value = true));

  return computed(() => (mounted.value ? clientUser.value : serverUser.value));
}
